var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GraphQLClient } from "graphql-request";
import { newrelic } from "@jti/fe-clients";
import { GraphQLError } from "../GraphQLError/GraphQLError";
export class ClientGraphQL extends GraphQLClient {
    request(document, variables, requestHeaders) {
        const _super = Object.create(null, {
            request: { get: () => super.request }
        });
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield _super.request.call(this, document, variables, requestHeaders);
            }
            catch (error) {
                const graphQLError = new GraphQLError(error, document, variables);
                graphQLError.log();
                newrelic.noticeError(graphQLError);
                throw graphQLError;
            }
        });
    }
}
//# sourceMappingURL=ClientGraphQL.js.map